exports = module.exports = require("../../../../../../.config/yarn/global/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brainstorm-app,.brainstorm-app *{box-sizing:border-box!important}", ""]);

// exports
